/**
 Estados de IPTELMEX
 **/
export const IPTELMEX_REGISTER = 'register';
export const IPTELMEX_SUBSCRIPTION = 'subscription';
export const IPTELMEX_ACTIVATION = 'activation';
export const IPTELMEX_ACCEPT = 'accept';
export const IPTELMEX_ACCEPT_TERM = 'accept_term_and_cond';
/**
 Estados derivados de una accion
 **/
export const IPTELMEX_LOGIN = 'login';
export const IPTELMEX_LOGIN_REMINDER = 'reminder';
export const IPTELMEX_SKIP = 'skip';
export const IPTELMEX_WITHOUT_MAIL = 'register_without_mail';
export const IPTELMEX_PRIVACY_POLICY = 'privacy_policy';

/**
 * Analytics.
 */
export const IPTELMEX_LOGIN_EVENT_ACTION = 'Inicia sesión';
export const IPTELMEX_LOGIN_EVENT_CATEGORY = 'Home';
export const IPTELMEX_LOGIN_EVENT_LABEL = 'Usuario y contraseña';
export const IPTELMEX_LOGIN_EVENT_SUCCESS_LABEL = 'Exitoso Usuario y contraseña';
export const IPTELMEX_LOGIN_EVENT_ERROR_LABEL_PREFIX = 'Auto_Login_IpTelmex';

export const IPTELMEX_REGISTRY_EVENT_ACTION = 'Registro Exitoso';
export const IPTELMEX_REGISTRY_EVENT_CATEGORY = 'Home';
export const IPTELMEX_REGISTRY_EVENT_LABEL = 'IP Telmex';
export const IPTELMEX_REGISTRY_EVENT_SUCCESS_LABEL = 'Exitoso - IP Telmex';
export const IPTELMEX_REGISTRY_EVENT_ERROR_LABEL_PREFIX = 'Registro iptelmex';



// WEBPACK FOOTER //
// ./src/containers/IPTelmex/constants.js